import EmptyFieldsList from './emptyFieldsList';

export default EmptyFieldsList;
